import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import ProtectedRouteHoc from './views/routing/ProtectedRouteHoc';
import Dashboard from './views/Dashboard';
import EmailLogin from './views/EmailLogin';
import SignUp from './views/SignUp';
const propTypes = {};

const defaultProps = {};

export default function AppRouter(_props: {}) {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/login"
          key="/login"
          component={EmailLogin}
          exact={true}
        />
        <Route
          path="/signup"
          key="/signup"
          component={SignUp}
          exact={true}
        />

        <ProtectedRouteHoc
          exact={true}
          key="/dashboard"
          path="/"
          fallback="login"
          component={Dashboard}
        />
      </Switch>
    </BrowserRouter>
  );
}

AppRouter.propTypes = propTypes;
AppRouter.defaultProps = defaultProps;